import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { ReactComponent as Cross } from "../../../assets/analyse/Cross.svg";

// REDUX
import { useDispatch, useSelector } from "react-redux";
import { signOut } from "../../../redux/actions/authActions";
import { getBillingManagementPortal, updateSubscriptionItems, fetchSubscription } from "../../../redux/actions/userActions";
// import { signInWithEmailLink_ } from "../../redux/actions/authActions";
import { auth, db_firestore } from "../../../firebase/config";
// NAVIGATE
import { useNavigate } from "react-router-dom";
import Slider from "@mui/material/Slider";
import MainButton from "../../../commonComponents/MainButton";
import { fabClasses } from "@mui/material";
import getStripe from "./initializeStripe";
import Subscription from "./Subscription";
import { data } from "autoprefixer";
import Modal from "react-modal";
import ComponentLoading from "../../../commonComponents/ComponentLoading";
// import ComponentLoading from "../../commonComponents/ComponentLoading";

const SubscriptionCard = (props) => {
  //   const navigate = useNavigate();

  const dispatch = useDispatch();
  const getBillingManagementPortal_rd = (item) => dispatch(getBillingManagementPortal(item));
  const fetchSubscription_rd = (item) => dispatch(fetchSubscription(item));
  const updateSubscriptionItems_rd = (item) => dispatch(updateSubscriptionItems(item));
  const user_info = useSelector((state) => (state.user.user_info ? state.user.user_info : null));
  const subscription = useSelector((state) => (state.user.subscription ? state.user.subscription : null));
  const products = useSelector((state) => (state.user.products ? state.user.products : null));
  const cancel_at_period_end = subscription ? Object.values(subscription)[0].cancel_at_period_end : null;
  const cond_subscription = subscription ? !cancel_at_period_end && Object.values(subscription)[0].items.some((x) => x.plan.product === props.data[0]) : null;
  const cond_subscription_both = subscription ? !cancel_at_period_end && Object.entries(products).some((y) => Object.values(subscription)[0].items.some((x) => x.plan.product === y[0])) : null;

  const [price, setPrice] = useState(null);

  const [updateSuccess, setUpdateSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const standard_user_price = 29;
  const standard_product_price = 49;
  const essential_user_price = 19;
  const essential_product_price = 39;

  const get_quantity_essential = (type) => {
    let res;
    if (type === "users") {
      if (cancel_at_period_end) {
        res = props.data[1].metadata.init_users;
      } else {
        if (props.data[1].name.split(" ")[0] === "Essential") {
          const cond_subs_usr_ess = subscription ? Object.values(subscription)[0].items.some((x) => x.plan.product === props.users_essential_product) : null;
          if (cond_subs_usr_ess) {
            res = parseFloat(Object.values(subscription)[0].items.find((x) => x.plan.product === props.users_essential_product).quantity) + parseFloat(props.data[1].metadata.init_users);
          } else {
            res = props.data[1].metadata.init_users;
          }
        }
      }
    } else if (type === "products") {
      if (cancel_at_period_end) {
        res = props.data[1].metadata.init_products;
      } else {
        if (props.data[1].name.split(" ")[0] === "Essential") {
          const cond_subs_prod_ess = subscription ? Object.values(subscription)[0].items.some((x) => x.plan.product === props.products_essential_product) : null;
          if (cond_subs_prod_ess) {
            res = parseFloat(Object.values(subscription)[0].items.find((x) => x.plan.product === props.products_essential_product).quantity) + parseFloat(props.data[1].metadata.init_products);
          } else {
            res = props.data[1].metadata.init_products;
          }
        }
      }
    }
    return parseFloat(res);
  };

  const get_quantity_standard = (type) => {
    let res;
    if (type === "users") {
      if (cancel_at_period_end) {
        res = props.data[1].metadata.init_users;
      } else {
        if (props.data[1].name.split(" ")[0] === "Standard") {
          const cond_subs_usr_std = subscription ? Object.values(subscription)[0].items.some((x) => x.plan.product === props.users_standard_product) : null;
          if (cond_subs_usr_std) {
            res = parseFloat(Object.values(subscription)[0].items.find((x) => x.plan.product === props.users_standard_product).quantity) + parseFloat(props.data[1].metadata.init_users);
          } else {
            res = props.data[1].metadata.init_users;
          }
        }
      }
    } else if (type === "products") {
      if (cancel_at_period_end) {
        res = props.data[1].metadata.init_products;
      } else {
        if (props.data[1].name.split(" ")[0] === "Standard") {
          const cond_subs_prod_std = subscription ? Object.values(subscription)[0].items.some((x) => x.plan.product === props.products_standard_product) : null;
          if (cond_subs_prod_std) {
            res = parseFloat(Object.values(subscription)[0].items.find((x) => x.plan.product === props.products_standard_product).quantity) + parseFloat(props.data[1].metadata.init_products);
          } else {
            res = props.data[1].metadata.init_products;
          }
        }
      }
    }
    return parseFloat(res);
  };

  const [isSetQuantity, setIsSetQuantity] = useState(false);
  const [number_users, set_number_users] = useState(props.data[1].name.split(" ")[0] === "Standard" ? get_quantity_standard("users") : get_quantity_essential("users"));
  const [number_products, set_number_products] = useState(parseFloat(props.data[1].name.split(" ")[0] === "Standard" ? get_quantity_standard("products") : get_quantity_essential("products")));
  // const [number_users, set_number_users] = useState(3);
  // const [number_products, set_number_products] = useState(3);

  useEffect(() => {
    if (props.data[1].prices) {
      const price_string = props.data[1].prices.priceData.unit_amount.toString();
      setPrice(price_string.slice(0, price_string.length - 2));
    }
  }, [props.data[1].prices]);

  async function createCheckoutSession(uid: string, item) {
    const env = process.env.REACT_APP_NODE_ENV;
    let url;
    if (env === "PROD") {
      url = "https://lokalite-saas.web.app/";
    } else if (env === "DEV") {
      url = "http://localhost:3000/";
    }

    // Create a new checkout session in the subollection inside this users document
    const checkoutSessionRef = await db_firestore
      .collection("users")
      .doc(uid)
      .collection("checkout_sessions")
      .add({
        // replace the price_XXX value with the correct value from your product in stripe.
        line_items: item.price_ids,
        // line_items: items_ids,
        success_url: url + "PaymentSuccess",
        cancel_url: url + "PaymentError",
      });

    console.log("created DOc");

    // Wait for the CheckoutSession to get attached by the extension
    await checkoutSessionRef.onSnapshot(async (snap) => {
      const { sessionId } = snap.data();
      console.log("sessionId", sessionId);
      if (sessionId) {
        // We have a session, let's redirect to Checkout
        // Init Stripe
        const stripe = await getStripe();
        stripe.redirectToCheckout({ sessionId });
      }
    });
  }

  const handleChangeSubcribe = async () => {
    ////// collect pricess ids
    let priceIds_quantity = [];

    // add main plan
    priceIds_quantity.push({ price: props.data[1].prices.priceId, quantity: 1 });

    // if adding products
    if (parseFloat(props.data[1].metadata.init_products) !== parseFloat(number_products)) {
      console.log("handleChangeSubcribe - addingproducts", props.data[1].metadata.init_products, number_products);
      if (props.data[1].name.split(" ")[0] === "Standard") {
        priceIds_quantity.push({ price: props.products_standard_id, quantity: parseFloat(number_products) - parseFloat(props.data[1].metadata.init_products) });
      } else if (props.data[1].name.split(" ")[0] === "Essential") {
        priceIds_quantity.push({ price: props.products_essential_id, quantity: parseFloat(number_products) - parseFloat(props.data[1].metadata.init_products) });
      }
    }
    // if adding users
    if (parseFloat(props.data[1].metadata.init_users) !== parseFloat(number_users)) {
      if (props.data[1].name.split(" ")[0] === "Standard") {
        priceIds_quantity.push({ price: props.users_standard_id, quantity: parseFloat(number_users) - parseFloat(props.data[1].metadata.init_users) });
      } else if (props.data[1].name.split(" ")[0] === "Essential") {
        priceIds_quantity.push({ price: props.users_essential_id, quantity: parseFloat(number_users) - parseFloat(props.data[1].metadata.init_users) });
      }
    }

    const item = {
      customer_id: user_info.stripeId,
      price_ids: priceIds_quantity,
    };

    // create and open checkout seession
    await createCheckoutSession(auth.currentUser.uid, item);
  };

  const getSubscription = async () => {
    let subscription = {};
    await db_firestore
      .collection("users")
      .doc(auth.currentUser.uid)
      .collection("subscriptions")
      .get()
      .then(async (querySnapshot) => {
        // console.log("toto",querySnapshot.docs[0].exists);
        await querySnapshot.docs.forEach(async (subSnapshot) => {
          console.log("subSnapshot", subSnapshot.data());
          console.log("id", subSnapshot.id);
          subscription[subSnapshot.id] = subSnapshot.data();
        });
      });
  };

  const get_update_message = () => {
    const current_period_start = Object.values(subscription)[0].current_period_start;
    const current_period_end = Object.values(subscription)[0].current_period_end;
    const cancel_at_period_end = Object.values(subscription)[0].cancel_at_period_end;
    let message;
    if (cancel_at_period_end) {
      let date = new Date(current_period_end.seconds * 1000);
      let ye = new Intl.DateTimeFormat("fr", { year: "numeric" }).format(date);
      let mo = new Intl.DateTimeFormat("fr", { month: "2-digit" }).format(date);
      let da = new Intl.DateTimeFormat("fr", { day: "2-digit" }).format(date);
      message = `Annulé : s'achève le ${da}/${mo}/${ye}`;
    } else {
      let da = (current_period_end.seconds - current_period_start.seconds) / (3600 * 24);
      message = `${da}j avant renouvellement auto.`;
    }
    return message;
  };

  const get_offer_price = () => {
    if (parseFloat(price) && props.data[1].name.split(" ")[0] === "Standard") {
      return (
        parseFloat(price) +
        (parseFloat(number_users) - parseFloat(props.data[1].metadata.init_users)) * standard_user_price +
        (parseFloat(number_products) - parseFloat(props.data[1].metadata.init_products)) * standard_product_price
      );
    } else {
      return parseFloat(price) + (number_users - props.data[1].metadata.init_users) * essential_user_price + (number_products - props.data[1].metadata.init_products) * essential_product_price;
    }
  };

  const get_cond_modif_plan = () => {
    if (!(user_info.organization_info.role.name === "Administrateur")) {
      return true;
    } else if (cond_subscription) {
      return true;
    } else if (cond_subscription_both) {
      return false;
    } else {
      return true;
    }
  };

  const handleChangeUpdateSubscriptionitems = async () => {
    const subscription_id = Object.keys(subscription)[0];
    let users_sub_id;
    let products_sub_id;
    if (props.data[1].name.split(" ")[0] === "Standard") {
      users_sub_id = Object.values(subscription)[0].items.find((x) => x.plan.product === props.users_standard_product).id;
      products_sub_id = Object.values(subscription)[0].items.find((x) => x.plan.product === props.products_standard_product).id;
    } else {
      users_sub_id = Object.values(subscription)[0].items.find((x) => x.plan.product === props.users_essential_product).id;
      products_sub_id = Object.values(subscription)[0].items.find((x) => x.plan.product === props.products_essential_product).id;
    }

    // format data
    const item = {
      subscription_id: subscription_id,
      items: [
        {
          id: users_sub_id,
          quantity: parseFloat(number_users) - parseFloat(props.data[1].metadata.init_users),
        },
        {
          id: products_sub_id,
          quantity: parseFloat(number_products) - parseFloat(props.data[1].metadata.init_products),
        },
      ],
    };

    // update subscription
    let response = await updateSubscriptionItems_rd(item);

    if (response.data) {
      setUpdateSuccess(true);
    }
  };

  return (
    <div className={(cond_subscription ? "border-4 border-blue-500 shadow-blue-500" : "border border-gray-100") + " flex flex-col p-6 w-[300px] h-[460px] text-gray-900 bg-white rounded-lg shadow"}>
      {/* HEADER */}
      <div className="flex flex-row justify-between items-baseline align-middle">
        <h3 className="mb-4 text-xl font-semibold">{props.data[1].name.split(" ")[0]}</h3>
        <div className="flex justify-center items-baseline">
          <span className="mr-2 text-3xl font-extrabold">{price && get_offer_price()}€</span>
          <span className="text-gray-500 dark:text-gray-400">/month</span>
        </div>
      </div>

      {/*  Slider users */}
      <div className="flex flex-row justify-between items-center">
        <span className="font-Poppins-Light text-xs">Utilisateurs</span>
        <div className=" flex w-[160px] items-center justify-between">
          {/* <span className="mr-[5px] font-Poppins-Light text-xs">{props.data[1].name.split(" ")[0] === "Standard" ? get_quantity_standard("users") : get_quantity_essential("users")}</span> */}
          <span className="mr-[5px] font-Poppins-Light text-xs">{parseFloat(props.data[1].metadata.init_users)}</span>
          <div className="flex w-[120px] items-center">
            <Slider
              // min={parseFloat(props.data[1].name.split(" ")[0] === "Standard" ? get_quantity_standard("users") : get_quantity_essential("users"))}
              min={parseFloat(props.data[1].metadata.init_users)}
              max={50}
              //   disabled={cond_subscription}
              //   valueLabelDisplay="on"
              value={number_users}
              defaultValue={0}
              onChange={(event, newValue) => {
                set_number_users(newValue);
              }}
            />
          </div>
          <span className=" w-[10px] font-Poppins-Light text-xs">{number_users}</span>
        </div>
      </div>

      {/*  Slider products */}
      <div className="flex flex-row justify-between items-center">
        <span className="font-Poppins-Light text-xs">Produits</span>
        <div className="flex w-[160px] items-center justify-between">
          <span className="mr-[5px] font-Poppins-Light text-xs">{parseFloat(props.data[1].metadata.init_products)}</span>
          <div className="flex w-[120px] items-center">
            <Slider
              min={parseFloat(props.data[1].metadata.init_products)}
              max={100}
              value={number_products}
              defaultValue={0}
              onChange={(event, newValue) => {
                set_number_products(newValue);
              }}
            />
          </div>
          <span className=" w-[10px] font-Poppins-Light text-xs">{number_products}</span>
        </div>
      </div>

      {/* FEATURES */}
      <span className={(props.data[1].name.split(" ")[0] === "Standard" ? "font-Poppins-Light" : "font-Poppins-SemiBold") + " text-xs my-[15px] text-center"}>
        {props.data[1].name.split(" ")[0] === "Standard"
          ? "+" + standard_product_price + "€/ produit, +" + standard_user_price + "€/ utilisateurs"
          : "+" + essential_product_price + "€/ produit, +" + essential_user_price + "€/ utilisateurs"}
      </span>

      {/* <!-- List --> */}
      <ul role="list" className="mb-8 space-y-4 text-left">
        <li className="flex items-center space-x-3">
          {/* <!-- Icon --> */}
          <svg className="flex-shrink-0 w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path>
          </svg>
          <span className="font-Poppins-Light text-xs">Accès complets aux bases de données</span>
        </li>
        <li className="flex items-center space-x-3">
          {/* <!-- Icon --> */}
          <svg className="flex-shrink-0 w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path>
          </svg>
          <span className="font-Poppins-Light text-xs">Module d'Analyse de Cycle de Vie</span>
        </li>
        <li className="flex items-center space-x-3">
          {/* <!-- Icon --> */}
          <svg className="flex-shrink-0 w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path>
          </svg>
          <span className="font-Poppins-Light text-xs">
            Module d'éco-conception <span className="font-Poppins-SemiBold text-xs">{props.data[1].name.split(" ")[0] === "Standard" ? "limité" : "illimité"}</span>
          </span>
        </li>
        <li className="flex items-center space-x-3">
          {/* <!-- Icon --> */}
          <svg className="flex-shrink-0 w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path>
          </svg>
          <span className="font-Poppins-Light text-xs">Module de communication</span>
        </li>
        <li className="flex items-center space-x-3">
          {/* <!-- Icon --> */}
          <svg className="flex-shrink-0 w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path>
          </svg>
          <span className="font-Poppins-Light text-xs">Assistance 24h/24 et 7j/7</span>
        </li>
      </ul>

      <div className="flex flex-row">
        <div
          className={
            (cond_subscription && cond_subscription_both ? "" : "pl-[40px]") +
            " text-xs h-[35px] w-[200px] rounded-lg  text-white font-Poppins-SemiBold justify-center items-center align-center content-center"
          }
        >
          <MainButton
            disabled={get_cond_modif_plan()}
            callback={async () => {
              if (!cond_subscription_both) {
                await handleChangeSubcribe();
              } else {
                // allow to manage
                const url = await getBillingManagementPortal_rd({ customer_id: user_info.stripeId });
                if (url) {
                  window.open(url, "_blank", "noopener,noreferrer");
                }
              }
            }}
            title={cond_subscription ? "Gérer" : "Choisir"}
            styleWind={(cond_subscription ? "bg-blue-500" : "") + " text-xs"}
          />
        </div>

        {cond_subscription && cond_subscription_both && (
          <div className={"text-xs h-[35px] w-[200px] rounded-lg pl-[10px] text-white font-Poppins-SemiBold justify-center items-center align-center content-center"}>
            <MainButton
              // disabled={user_info.organization_info.role.access.analyse.write}
              disabled={cond_subscription ? true : cond_subscription_both ? false : true}
              //   disabled={true}
              callback={async () => {
                setIsSetQuantity(true);
                setUpdateSuccess(false);
              }}
              title={"Modifier"}
              styleWind={(cond_subscription ? "bg-blue-500" : "") + " text-xs"}
            />
          </div>
        )}

        <Modal
          onRequestClose={async () => {
            if (updateSuccess) {
              // fetch subscription
              console.log("onRequestClose FETCHING");
              await fetchSubscription_rd({ user_id: auth.currentUser.uid });
            }
          }}
          isOpen={isSetQuantity}
          onBackdropPress={() => setIsSetQuantity(false)}
          style={{
            content: {
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: 330,
              width: 580,
              borderRadius: 20,
              borderWidth: 0,
              boxShadow: "0px 0px 2px #9E9E9E",
            },
          }}
        >
          <div className=" h-full grid justify-items-center">
            {/* <p className="font-Poppins-SemiBold text-4xl flex text-center mt-[50px]">TITRE</p> */}
            <div className="w-[520px] h-full border-b-[1px] border-mainGrey flex justify-start items-center">
              <p className="text-xl font-Poppins-SemiBold">Modifier le nombre d'utiliateurs</p>
            </div>

            <div className="w-[300px] mt-[20px]">
              <div className="flex flex-row justify-between items-baseline align-middle">
                <h3 className="mb-4 text-xl font-semibold">{props.data[1].name.split(" ")[0]}</h3>
                <div className="flex justify-center items-baseline">
                  <span className="mr-2 text-3xl font-extrabold">{price && get_offer_price()}€</span>
                  <span className="text-gray-500 dark:text-gray-400">/month</span>
                </div>
              </div>

              {/*  Slider users */}
              <div className="flex flex-row justify-between items-center">
                <span className="font-Poppins-Light text-xs">Utilisateurs</span>
                <div className=" flex w-[160px] items-center justify-between">
                  {/* <span className="mr-[5px] font-Poppins-Light text-xs">{props.data[1].name.split(" ")[0] === "Standard" ? get_quantity_standard("users") : get_quantity_essential("users")}</span> */}
                  <span className="mr-[5px] font-Poppins-Light text-xs">{parseFloat(props.data[1].metadata.init_users)}</span>
                  <div className="flex w-[120px] items-center">
                    <Slider
                      min={parseFloat(props.data[1].metadata.init_users)}
                      max={50}
                      //   disabled={cond_subscription}
                      //   valueLabelDisplay="on"
                      // defaultValue={0}
                      value={number_users}
                      onChange={(event, newValue) => {
                        set_number_users(newValue);
                      }}
                    />
                  </div>
                  <span className=" w-[10px] font-Poppins-SemiBold text-xs">{number_users}</span>
                </div>
              </div>
              {/*  Slider products */}
              <div className="flex flex-row justify-between items-center">
                <span className="font-Poppins-Light text-xs">Produits</span>
                <div className="flex w-[160px] items-center justify-between">
                  <span className="mr-[5px] font-Poppins-Light text-xs">{parseFloat(props.data[1].metadata.init_products)}</span>
                  <div className="flex w-[120px] items-center">
                    <Slider
                      min={parseFloat(props.data[1].metadata.init_products)}
                      max={100}
                      //   disabled={cond_subscription}
                      //   disabled
                      //   valueLabelDisplay="on"
                      // defaultValue={0}
                      value={number_products}
                      onChange={(event, newValue) => {
                        set_number_products(newValue);
                      }}
                    />
                  </div>
                  <span className=" w-[10px] font-Poppins-SemiBold text-xs">{number_products}</span>
                </div>
              </div>
            </div>

            <div className="cursor-pointer absolute right-2">
              {loading ? (
                <ComponentLoading height={20} style={"h-full mr-[6px]"} />
              ) : (
                <Cross
                  height={20}
                  onClick={async () => {
                    if (updateSuccess) {
                      // fetch subscription
                      setLoading(true);
                      console.log("onRequestClose FETCHING");
                      await fetchSubscription_rd({ user_id: auth.currentUser.uid });
                      setLoading(false);
                    }
                    setIsSetQuantity(false);
                  }}
                />
              )}
            </div>
            <div className="flex items-center w-[200px] justify-center h-[40px] mt-[30px]">
              <MainButton
                success={updateSuccess}
                disabled={true}
                callback={async () => {
                  // get data
                  await handleChangeUpdateSubscriptionitems();
                }}
                title={"Valider"}
                styleWind={"text-xs px-[10px]"}
              />
            </div>

            <span className="font-Poppins-Light text-sm text-center mt-[7px]">L'abonnement sera mis-à-jour automatiquement.</span>
          </div>
        </Modal>
      </div>

      {cond_subscription && <span className="font-Poppins-Light text-xs text-center mt-[7px]">{cond_subscription && get_update_message()}</span>}
    </div>
  );
};

export default SubscriptionCard;
